import BaseApi from "./base-api";
import { DefaultNodeRequestInterceptor } from "../interceptors";
export default class NodeApi extends BaseApi {
    defaultRequestInterceptors() {
        return [
            DefaultNodeRequestInterceptor
        ];
    }
    defaultResponseInterceptors() {
        return [];
    }
}
